import { atom, atomFamily, selectorFamily } from 'recoil';
import { ObeService } from 'api';
export const getObeDetailsRequestIdState = atom({
  key: 'getObeDetailsRequestIdState',
  default: 0
});
export const getObeDetails = selectorFamily({
  key: 'getObeDetails',
  get: obeNumber => async ({
    get
  }) => {
    get(getObeDetailsRequestIdState);
    if (!obeNumber) return {};
    try {
      return await ObeService.getObeDetails({
        obeNumber
      });
    } catch (e) {
      console.error(`${e}: Could not fetch OBE details`);
    }
    return {};
  }
});
export const getObeAtom = atomFamily({
  key: 'getObeAtom',
  default: obeNumber => getObeDetails(obeNumber)
});